import { yupResolver } from '@hookform/resolvers/yup';
import { SubmitHandler, useForm } from 'react-hook-form';
import * as yup from 'yup';

import { useUpdateUserMaxSuperLikesMutation } from '../../../../event/hooks/useUpdateUserMaxSuperLikesMutation';

interface OrgaSuperLikeInputs {
  maxSuperLikes: number;
}

const schema = yup
  .object({
    maxSuperLikes: yup
      .number()
      .positive('Le nombre de super like doit être positif')
      .required('Le nombre de super likes est requis'),
  })
  .required();

export const useSuperLikeDialog = ({
  defaultMaxSuperLikes,
  eventId,
  onClose,
  userId,
}: {
  eventId: string;
  userId: string;
  onClose: () => void;
  defaultMaxSuperLikes: number;
}) => {
  const { updateMaxSuperLikes } = useUpdateUserMaxSuperLikesMutation();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<OrgaSuperLikeInputs>({
    resolver: yupResolver(schema),
    defaultValues: {
      maxSuperLikes: defaultMaxSuperLikes,
    },
  });

  const onValid: SubmitHandler<OrgaSuperLikeInputs> = (data) => {
    updateMaxSuperLikes({
      eventId,
      userId,
      maxSuperLikes: data.maxSuperLikes,
    });
    onClose();
  };

  const onSubmit = handleSubmit(onValid);

  return {
    onSubmit,
    errors,
    register,
  };
};
